import { router } from "@inertiajs/vue3";
import { onMounted, onUnmounted, ref } from "vue";

export const useIsPageLoading = () => {
    //THIS IS SETTING HASLOADED - USED FOR E2E TESTS

    const timeoutKey = ref<number | undefined>();
    const unsubscribeBeforeLoad = ref<() => void>();
    const unsubscribeFinishedLoad = ref<() => void>();
    const unsubscribeNavigateLoad = ref<() => void>();

    const setFinishedLoad = () => {
        clearTimeout(timeoutKey.value);
        timeoutKey.value = window.setTimeout(() => {
            window.hasLoaded = true;
        }, 2000);
    };

    const setBeforeLoad = () => {
        clearTimeout(timeoutKey.value);
        window.hasLoaded = false;
    };

    onMounted(() => {
        setFinishedLoad();
        unsubscribeBeforeLoad.value = router.on("before", setBeforeLoad);
        unsubscribeFinishedLoad.value = router.on("finish", setFinishedLoad);
        unsubscribeNavigateLoad.value = router.on("navigate", setFinishedLoad);
    });

    onUnmounted(() => {
        if (unsubscribeBeforeLoad.value) unsubscribeBeforeLoad.value();
        if (unsubscribeFinishedLoad.value) unsubscribeFinishedLoad.value();
        if (unsubscribeNavigateLoad.value) unsubscribeNavigateLoad.value();
    });
};
